import { cloneDeep, get } from 'lodash';

let pageConfig = null;

function _init() {
    if (pageConfig === null) {
        pageConfig = window.tricareConfigData;
    }
}

function _getPageConfig(){
    _init();
    let pageConfigResponse = null;
    if (pageConfig !== null) {
        pageConfigResponse = cloneDeep(pageConfig);
    } else {
        throw 'page configuration not available yet';
    }
    return pageConfigResponse;
}

function _getPageConfigProperty(propertyName) {
    return get(_getPageConfig(), propertyName);
}

export function getPageConfig() {
    return _getPageConfig();
}

export function getPageConfigProperty(propertyName) {
    return _getPageConfigProperty(propertyName);
}
